import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.recrutalentos.automacaocuritiba.com/',
});

export default api;
